module.exports = __webpack_public_path__ + "media/images/project/x-f0154d3586b9bf68c13e80f3635cc5f9.svg";